if (!customElements.get('sw-variant-picker')) {
  class SwVariantPicker extends HTMLElement {
    connectedCallback() {
      const data = this.querySelector('[data-sw-variants]');
      this.variants = data ? JSON.parse(data.textContent) : [];
      this.form = document.getElementById(this.dataset.formId);
      const button = this.form && this.form.querySelector('[name="add"]');
      const label = button && button.querySelector('span');
      this.availableLabel = label ? label.textContent.trim() : '';
      this.soldOutLabel = this.dataset.soldOut || 'SOLD';
      this.onChange = () => this.sync();
      this.addEventListener('change', this.onChange);
      this.sync();
    }

    disconnectedCallback() {
      this.removeEventListener('change', this.onChange);
    }

    selectedOptions() {
      return Array.from(this.querySelectorAll('[data-sw-option]')).map((group) => {
        const checked = group.querySelector('input:checked');
        return checked ? checked.value : '';
      });
    }

    sync() {
      const options = this.selectedOptions();
      const variant = this.variants.find((item) => item.options.every((value, index) => value === options[index]));
      const input = this.form && this.form.querySelector('[name="id"]');
      const button = this.form && this.form.querySelector('[name="add"]');
      const label = button && button.querySelector('span');
      const price = this.closest('.sw-pdp')?.querySelector('[data-sw-price]');

      this.querySelectorAll('[data-sw-option]').forEach((group) => {
        const current = group.querySelector('[data-sw-current]');
        const checked = group.querySelector('input:checked');
        if (current && checked) current.textContent = checked.value;
      });

      if (!variant) {
        if (input) input.disabled = true;
        if (button) button.disabled = true;
        return;
      }

      if (input) {
        input.value = variant.id;
        input.disabled = !variant.available;
        input.dispatchEvent(new Event('change', { bubbles: true }));
      }
      if (button) button.disabled = !variant.available;
      if (label && this.availableLabel) {
        label.textContent = variant.available ? this.availableLabel : this.soldOutLabel;
      }
      if (price && variant.price) price.textContent = variant.price;

      const url = new URL(window.location.href);
      url.searchParams.set('variant', variant.id);
      window.history.replaceState({}, '', url);

      const gallery = this.closest('.sw-pdp')?.querySelector('sw-gallery');
      if (!gallery || typeof gallery.showMatching !== 'function') return;
      const color = (this.optionValue('color') || this.optionValue('colour') || '').toLowerCase();
      const capacity = capacityToken(this.optionValue('variant') || this.optionValue('capacity') || '');
      gallery.showMatching((alt) => imageMatches(alt, color, capacity), variant.mediaId);
    }

    optionValue(name) {
      const group = this.querySelector(`[data-sw-option-name="${name}"]`);
      const checked = group && group.querySelector('input:checked');
      return checked ? checked.value : '';
    }
  }

  function capacityToken(value) {
    const match = String(value).trim().match(/^(\d+)\s+([A-Za-z]+)/);
    if (!match) return '';
    let noun = match[2].toLowerCase();
    if (noun.endsWith('es')) noun = noun.slice(0, -2);
    else if (noun.endsWith('s')) noun = noun.slice(0, -1);
    return `${match[1]}-${noun}`;
  }

  function mentionsColor(text, color) {
    const needle = ` in ${color}`;
    let from = 0;
    while (from < text.length) {
      const index = text.indexOf(needle, from);
      if (index < 0) return false;
      const after = text.slice(index + needle.length);
      const atBoundary = after.length === 0 || /^[\s,]/.test(after);
      const blueExtends = color === 'blue' && after.startsWith(' gold');
      if (atBoundary && !blueExtends) return true;
      from = index + needle.length;
    }
    return false;
  }

  function imageMatches(alt, color, capacity) {
    const text = String(alt || '').toLowerCase();
    if (capacity && !text.includes(capacity)) return false;
    if (!color) return true;
    if (mentionsColor(text, color)) return true;
    return !/ in (blue gold|navy|red|blue)\b/.test(text);
  }

  customElements.define('sw-variant-picker', SwVariantPicker);
}
